import React from 'react'
import ModalWrapper, { ModalActions } from './Modals/ModalWrapper'
import FormField, { TextInput, DateInput, TextArea } from './Forms/FormField'
import CheckboxField, { CheckIcon, StarIcon } from './Forms/CheckboxField'
import { useArtistEditor } from '../hooks/useArtistEditor'

const ArtistEditModal = ({ isOpen, onClose, onSave, artist, eventDates }) => {
  const { editedArtist, handleSave, updateField } = useArtistEditor(isOpen, artist, onSave, onClose)

  if (!isOpen || !artist) return null

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose} title="🎤 Edit Artist Details">
      <div className="space-y-4">
        <FormField label="Artist Name">
          <TextInput
            value={editedArtist.name}
            onChange={(e) => updateField('name', e.target.value)}
            placeholder="Enter artist name..."
          />
        </FormField>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField label="Performance Date">
            <DateInput
              value={editedArtist.performanceDate}
              onChange={(e) => updateField('performanceDate', e.target.value)}
            />
          </FormField>
          <FormField label="Set Time">
            <TextInput
              value={editedArtist.setTime}
              onChange={(e) => updateField('setTime', e.target.value)}
              placeholder="e.g., 9:30 PM, 21:30..."
            />
          </FormField>
        </div>

        <FormField label="Performance Details">
          <TextInput
            value={editedArtist.performance}
            onChange={(e) => updateField('performance', e.target.value)}
            placeholder="e.g., Main Stage, Day 2, Special Set..."
          />
        </FormField>

        <FormField label="Comment">
          <TextArea
            value={editedArtist.comment}
            onChange={(e) => updateField('comment', e.target.value)}
            placeholder="Share your thoughts about this performance..."
            maxLength={500}
          />
        </FormField>

        <div className="flex gap-4">
          <CheckboxField
            checked={editedArtist.seen}
            onChange={(e) => updateField('seen', e.target.checked)}
            label="Seen"
            icon={<CheckIcon filled={editedArtist.seen} />}
            checkedColor="text-green-400"
          />
          <CheckboxField
            checked={editedArtist.favorite}
            onChange={(e) => updateField('favorite', e.target.checked)}
            label="Favorite"
            icon={<StarIcon filled={editedArtist.favorite} />}
            checkedColor="text-yellow-400"
          />
        </div>
      </div>

      <ModalActions onCancel={onClose} onSave={handleSave} />
    </ModalWrapper>
  )
}

export default ArtistEditModal